import { Injectable } from '@angular/core';
import { AudioProvider } from '../components/ionic-audio';
import { MusicControls, MusicControlsOptions } from '@ionic-native/music-controls/ngx';
import { Platform, ToastController } from '@ionic/angular';
import { FirestoreService } from './FirestoreService';
import { BehaviorSubject, Subject } from 'rxjs';
import { SongPlayingService } from './songPlayingService';
import { AuthService } from './AuthService';
declare var $: any;

@Injectable()
export class AudioService {
  trackIndex: number;
  song$: Subject<any[]> = new BehaviorSubject([]);

  isRepeat: number;
  isShuffle: boolean;
  pause$: Subject<boolean> = new BehaviorSubject(true);
  musicControls: typeof MusicControls;
  noSongPlaying: Subject<boolean> = new BehaviorSubject(true);
  songs: any;
  song: any;
  userId: any;
  tracks: any[] = []
  duration: any;
  recentArray: any[] = [];
  constructor(
    private platform: Platform,
    public audioProvider: AudioProvider,
    private toastCtrl: ToastController,
    private firestoreService: FirestoreService,
    private authService: AuthService,
    // private noSongPlaying: SongPlayingService,

    // private musicControls: MusicControlsOptions,
    // private musicControls: MusicControls,
    private firestore: FirestoreService
  ) // private events: Events
  {
    this.trackIndex = 0;
    this.isShuffle = false;
    this.isRepeat = 0;
    this.authService.afAuth.user.subscribe((user) => {
      if (user) {
        this.userId = user.uid;
        // this.getUserName.subscribe(name => console.log('name', name));
      }
    });
    this.getSongs();

  }

  progress() {
    return this.audioProvider.progress();
  }

  playingTrack() {
    // console.log("palying track", this.audioProvider);
    // this.pause$.next(false);
    console.log('audio provider played')
    return this.audioProvider.playingTrack();
  }

  setTracksAndPlay(tracks: any[], trackIndex: number): boolean {

    if (!this.audioProvider.canPlay()) {
      return false;
    }
    this.pause$.next(false);
    this.noSongPlaying.next(false);

    this.audioProvider.resetTracks();

    this.trackIndex = trackIndex;

    tracks.forEach((track) => {
      console.log({ track });
      this.audioProvider.create(track);
    });

    this.audioProvider.play(this.trackIndex, () => {

      // this.next();
    });

    if (this.platform.is('cordova')) {
      // this.initialiseMusicControls(tracks[this.trackIndex]);
    }

    return true;
  }



  play() {

    this.pause$.next(false);
    console.log('track index ', this.trackIndex);
    this.audioProvider.play(this.trackIndex, () => {
      console.log('song is played');


      // this.next();
    });

    // this.musicControls.updateIsPlaying(true);
  }

  pause() {
  
    this.pause$.next(true);
    this.firestore.setSongPlayingDuration(true);
    this.audioProvider.pause();
    // this.musicControls.updateIsPlaying(false);
  }

  next() {
    this.pause$.next(false);

    // this.firestore.setSongPlayingDuration(true);

    if (this.audioProvider.current != undefined) {
      if (this.isShuffle) {
        // loop until find appropriate random index
        while (true) {
          let randomIndex = Math.floor(
            Math.random() * this.audioProvider.tracks.length
          );

          if (randomIndex != this.audioProvider.current) {
            this.trackIndex = randomIndex;
            this.playNextOrPrevious();
            break;
          }
        }
      } else {
        console.log("audio provider tracks ",this.audioProvider.tracks);
        if (this.audioProvider.current < this.audioProvider.tracks.length - 1) {
          this.trackIndex = this.audioProvider.current + 1;
        } else {
          this.trackIndex = 0;
        }

        this.playNextOrPrevious();
      }
    }
  }

  previous() {
    this.pause$.next(false);

    if (this.audioProvider.current != undefined) {
      if (this.isShuffle) {
        // loop until find appropriate random index
        while (true) {
          let randomIndex = Math.floor(
            Math.random() * this.audioProvider.tracks.length + 0
          );

          if (randomIndex != this.audioProvider.current) {
            this.trackIndex = randomIndex;
            this.playNextOrPrevious();
            break;
          }
        }
      } else {
        this.stop();
        if (this.audioProvider.current > 0) {
          this.trackIndex = this.audioProvider.current - 1;
        } else {
          this.trackIndex = this.audioProvider.tracks.length - 1;
        }

        this.playNextOrPrevious();
      }
    }
  }

  playNextOrPrevious() {
    // console.log('previus', this.audioProvider.current)
    if (this.audioProvider.current != undefined) {
      this.audioProvider.pause();
      this.audioProvider.seekTo(0);
    }

    this.audioProvider.play(this.trackIndex, () => {
      this.next();
    });

    if (this.platform.is('cordova')) {
      // this.initialiseMusicControls(this.audioProvider.tracks[this.trackIndex]);
      // this.musicControls.updateIsPlaying(true);
    }
  }





  playPause() {
    console.log('pause value', this.pause$['value'])
    if (this.pause$['value']) {
      // this.audioService.play();
      // this.audioService.pause$.next(false);

    } else {
      this.pause();
      // this.audioService.pause$.next(true);


    }

  }

  playSong(trackIndex: number) {
    if (trackIndex == undefined) return;
    if (this.setTracksAndPlay(this.tracks, trackIndex)) {
      // this.audioService.pause$.next(false);
    
      this.song = this.songs[trackIndex];
      this.duration = this.song.duration;
      this.firestoreService.setSongPlayingDuration(false);
      // console.log('recent array', this.recentArray);
      if (this.recentArray[this.recentArray.length - 1] != trackIndex)
        this.recentArray.push(trackIndex);
      this.firestoreService.addSongToRecentlyPlayed(
        this.userId,
        this.songs[trackIndex]
      );
        this.noSongPlaying.next(false);
      this.pause$.next(false);
      this.updateSongIsPlaying();
    }
  }


  getDuration(src) {
    return new Promise(function (resolve) {
      var audio = new Audio();
      $(audio).on('loadedmetadata', function () {
        resolve(audio.duration);
      });
      audio.src = src;
    });
  }

  getSongs() {
    this.firestoreService.getSongs().then((result: any) => {
      this.songs = result.songs;


      // console.log('rounded', len);
      var song = this.songs.map((el: any) => {
        var o = Object.assign({}, el);
        this.getDuration(el.songUrl).then(function (length: number) {
          // console.log('I got length ', length);
          // var roundedLength = Math.round(length / 60);
          o.duration = length;
        });
        return o;
      });
      this.songs = song;
      console.log('songs', this.songs);
      this.song$.next(this.songs);

      this.songs.forEach((song) => {
        var track = {
          src: song.songUrl,
          artist: song.artistName,
          title: song.name,
          art: song.albumPicture,
          preload: 'metadata', // tell the plugin to preload metadata such as duration for this track, set to 'none' to turn off
          songId: song.songId,
          artistId: song.artistId,
          // duration: roundedLength,
          albumId: song.albumId,
        };

        this.tracks.push(track);
        // $("#duration").textContent = length;
      });

      // this.loadedSongs = true;
      this.updateSongIsPlaying();
    });
  }

  updateSongIsPlaying() {
    // if (this.loadedSongs && this.audioService.playingTrack() !== undefined) {
    //   this.songs.forEach((song) => {
    //     if (song.songId == this.audioService.playingTrack().songId) {
    //       song.isPlaying = true;
    //     } else {
    //       song.isPlaying = false;

    //     }
    //   });
    // }
  }








  async shuffle() {
    this.isShuffle = !this.isShuffle;

    let toast = await this.toastCtrl.create({
      message: 'Shuffle ' + (this.isShuffle ? 'ON' : 'OFF'),
      duration: 1000,
      position: 'bottom',
    });

    toast.present();
  }

  async repeat() {
    var repeatState = '';

    switch (this.isRepeat) {
      case 0:
        this.isRepeat = 1;
        repeatState = 'ON';
        break;

      case 1:
        this.isRepeat = 2;
        repeatState = 'ONCE';
        break;

      case 2:
        this.isRepeat = 0;
        repeatState = 'OFF';
        break;
    }

    let toast = await this.toastCtrl.create({
      message: 'Repeat ' + repeatState,
      duration: 1000,
      position: 'bottom',
    });

    toast.present();
  }

  seekTo(seek) {
    // let seek = this.audioProvider.tracks[0].progress + 5;
    // console.log({ seek });
    this.audioProvider.seekTo(seek);
  }

  seekBack() {
    let seek = this.audioProvider.tracks[0].progress - 5;
    this.audioProvider.seekTo(seek);
  }

  stop() {
    if (this.audioProvider.current != undefined) {
      this.audioProvider.seekTo(0);
      this.audioProvider.pause();
      this.pause$.next(true);

      // this.musicControls.updateIsPlaying(false);
    }
  }

  initialiseMusicControls(track) {
    this.musicControls.create({
      track: track.title, // optional, default : ''
      artist: track.artist, // optional, default : ''
      cover: track.art, // optional, default : nothing
      // cover can be a local path (use fullpath 'file:///storage/emulated/...', or only 'my_image.jpg' if my_image.jpg is in the www folder of your app)
      //           or a remote url ('http://...', 'https://...', 'ftp://...')
      isPlaying: true, // optional, default : true
      dismissable: true, // optional, default : false

      // hide previous/next/close buttons:
      hasPrev: true, // show previous button, optional, default: true
      hasNext: true, // show next button, optional, default: true
      hasClose: false, // show close button, optional, default: false

      // iOS only, optional
      album: track.albumName, // optional, default: ''
      duration: this.audioProvider.tracks[this.audioProvider.current].duration, // optional, default: 0
      elapsed: this.audioProvider.tracks[this.audioProvider.current].progress, // optional, default: 0
      hasSkipForward: true, // show skip forward button, optional, default: false
      hasSkipBackward: true, // show skip backward button, optional, default: false
      skipForwardInterval: 15, // display number for skip forward, optional, default: 0
      skipBackwardInterval: 15, // display number for skip backward, optional, default: 0
      hasScrubbing: false, // enable scrubbing from control center and lockscreen progress bar, optional

      // Android only, optional
      // text displayed in the status bar when the notification (and the ticker) are updated, optional
      ticker: 'Now playing ' + track.name,

      // All icons default to their built-in android equivalents
      // The supplied drawable name, e.g. 'media_play', is the name of a drawable found under android/res/drawable* folders
      playIcon: 'media_play',
      pauseIcon: 'media_pause',
      prevIcon: 'media_prev',
      nextIcon: 'media_next',
      closeIcon: 'media_close',
      notificationIcon: 'notification',
    });

    this.musicControls.subscribe().subscribe((action) => {
      const message = JSON.parse(action).message;

      switch (message) {
        case 'music-controls-next':
          this.next();
          // this.events.publish("updateSongIsPlaying");
          break;

        case 'music-controls-previous':
          this.previous();
          // this.events.publish("updateSongIsPlaying");
          break;

        case 'music-controls-pause':
          this.pause();
          break;

        case 'music-controls-play':
          this.play();
          break;

        case 'music-controls-destroy':
          this.musicControls.destroy();
          this.stop();
          break;

        // External controls (iOS only)
        case 'music-controls-toggle-play-pause':
          // Do something
          break;

        case 'music-controls-seek-to':
          const seekToInSeconds = JSON.parse(action).position;

          this.musicControls.updateElapsed({
            elapsed: seekToInSeconds,
            isPlaying: true,
          });
          break;

        case 'music-controls-skip-forward':
          this.seekTo(5);
          break;

        case 'music-controls-skip-backward':
          this.seekBack();
          break;

        // Headset events (Android only)
        // All media button events are listed below
        case 'music-controls-media-button':
          // Do something
          break;

        case 'music-controls-headset-unplugged':
          this.pause();
          break;

        case 'music-controls-headset-plugged':
          // Do something
          break;

        default:
          break;
      }
    });

    this.musicControls.listen(); // activates the observable above
  }
}
